export default __webpack_public_path__ + "pgnv-assets/9ecd94a016f31f4506b1e6bcc4adf69b.png";